import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: false,
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() searchText!: string;
  @Input() disabled = false;
  @Input() inputTabIndex = -1;
  @Input() placeHolderText = 'Find...';
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() searchSubmitted = new EventEmitter<string>();
  // This observable handles the debouncing.
  changes$ = new Subject<string>();

  constructor() {
    this.changes$
      .pipe(
        // Time in milliseconds
        debounceTime(250),
        // Ignore new term if same as previous term.
        distinctUntilChanged(),
      )
      .subscribe((text: string): void => {
        this.searchTextChange.emit(text);
      });
  }

  ngOnInit(): void {}

  onSearch(value: string) {
    this.changes$.next(value);
  }

  onClearSearch() {
    this.searchText = '';
    this.onSearch(this.searchText);
  }

  ngOnDestroy() {
    this.changes$.unsubscribe();
  }
}
